import { createPortal } from "react-dom";
import "./Modal.css";

const Modal = ({ open, onClose, children, maxWidth = 480, className = "", dismissible = true }) => {
  if (!open) return null;

  // Portaled to document.body instead of rendering inline where it's called
  // from — a Modal opened from inside ANY ancestor with a `transform`
  // (a Swiper carousel slide, a hover-lift card, an animated page wrapper)
  // would otherwise become fixed-positioned relative to that ancestor's box
  // instead of the viewport, landing off in a corner instead of centered.
  return createPortal(
    <div className="modal__overlay" onClick={dismissible ? onClose : undefined}>
      <div
        className={`modal__box ${className}`.trim()}
        style={{ maxWidth }}
        onClick={(e) => e.stopPropagation()}
      >
        {dismissible && (
          <button type="button" className="modal__close" onClick={onClose} aria-label="Close">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M2 2l12 12M14 2L2 14" stroke="#6B7280" strokeWidth="1.5" strokeLinecap="round" />
            </svg>
          </button>
        )}
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Modal;
